import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'kioskTicketTemplates';

// Action Types
export const types = {
  GET_KIOSK_TICKET_TEMPLATES: createAsyncTypes(`${KEY}/GET_KIOSK_TICKET_TEMPLATES`),
  CREATE_KIOSK_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/CREATE_KIOSK_TICKET_TEMPLATE`),
  UPDATE_KIOSK_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/UPDATE_KIOSK_TICKET_TEMPLATE`),
  DELETE_KIOSK_TICKET_TEMPLATE: createAsyncTypes(`${KEY}/DELETE_KIOSK_TICKET_TEMPLATE`),
  RESET_KIOSK_TICKET_TEMPLATES: `${KEY}/RESET_KIOSK_TICKET_TEMPLATES`,
  RESET_ERROR: `${KEY}/RESET_ERROR`,
  RESET_ACTION: `${KEY}/RESET_ACTION`
};

export interface KioskTicketTemplatesState {
  readonly kioskTicketTemplates: KioskTicketTemplate[];
  readonly action: {
    readonly success: boolean;
    readonly pending: boolean;
    readonly error: string | null;
  };
}

export interface KioskTicketTemplate {
  id: string;
  kioskId: string;
  ticketTemplateId: string;
}

export interface CreateKioskTicketTemplateRequest {
  type: typeof types.CREATE_KIOSK_TICKET_TEMPLATE.REQUEST;
  payload: CreateKioskTicketTemplatePayload;
}

export interface CreateKioskTicketTemplatePayload {
  kioskId: string;
  ticketTemplateId: string;
}

export interface ResetKioskTicketTemplates {
  type: typeof types.RESET_KIOSK_TICKET_TEMPLATES;
}

export interface GetKioskTicketTemplatesRequest {
  type: typeof types.GET_KIOSK_TICKET_TEMPLATES.REQUEST;
  payload: {
    kioskId: string;
  };
}

export interface GetKioskTicketTemplatesError {
  type: typeof types.GET_KIOSK_TICKET_TEMPLATES.ERROR;
  payload: string;
}

export interface GetKioskTicketTemplatesPending {
  type: typeof types.GET_KIOSK_TICKET_TEMPLATES.PENDING;
  payload: boolean;
}

export interface GetKioskTicketTemplatesSuccess {
  type: typeof types.GET_KIOSK_TICKET_TEMPLATES.SUCCESS;
  payload: KioskTicketTemplate[];
}

export type UpdateKioskTicketTemplatePayload = Partial<KioskTicketTemplate> & { id: string };

export interface UpdateKioskTicketTemplateRequest {
  type: typeof types.UPDATE_KIOSK_TICKET_TEMPLATE.REQUEST;
  payload: UpdateKioskTicketTemplatePayload;
}

export interface UpdateKioskTicketTemplateError {
  type: typeof types.UPDATE_KIOSK_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export interface UpdateKioskTicketTemplatePending {
  type: typeof types.UPDATE_KIOSK_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface UpdateKioskTicketTemplateSuccess {
  type: typeof types.UPDATE_KIOSK_TICKET_TEMPLATE.SUCCESS;
  payload: KioskTicketTemplate;
}

export interface CreateKioskTicketTemplateRequest {
  type: typeof types.CREATE_KIOSK_TICKET_TEMPLATE.REQUEST;
  payload: CreateKioskTicketTemplatePayload;
}

export interface CreateKioskTicketTemplateError {
  type: typeof types.CREATE_KIOSK_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export interface CreateKioskTicketTemplatePending {
  type: typeof types.CREATE_KIOSK_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface CreateKioskTicketTemplateSuccess {
  type: typeof types.CREATE_KIOSK_TICKET_TEMPLATE.SUCCESS;
}

export interface DeleteKioskTicketTemplateRequest {
  type: typeof types.DELETE_KIOSK_TICKET_TEMPLATE.REQUEST;
  payload: { id: string; kioskId: string };
}

export interface DeleteKioskTicketTemplateError {
  type: typeof types.DELETE_KIOSK_TICKET_TEMPLATE.ERROR;
  payload: string;
}

export interface DeleteKioskTicketTemplatePending {
  type: typeof types.DELETE_KIOSK_TICKET_TEMPLATE.PENDING;
  payload: boolean;
}

export interface DeleteKioskTicketTemplateSuccess {
  type: typeof types.DELETE_KIOSK_TICKET_TEMPLATE.SUCCESS;
}

export type KioskTicketTemplatesActionTypes =
  | ResetKioskTicketTemplates
  | GetKioskTicketTemplatesRequest
  | GetKioskTicketTemplatesSuccess
  | GetKioskTicketTemplatesError
  | GetKioskTicketTemplatesPending
  | UpdateKioskTicketTemplateRequest
  | UpdateKioskTicketTemplateSuccess
  | UpdateKioskTicketTemplateError
  | UpdateKioskTicketTemplatePending
  | CreateKioskTicketTemplateRequest
  | CreateKioskTicketTemplateSuccess
  | CreateKioskTicketTemplateError
  | CreateKioskTicketTemplatePending
  | DeleteKioskTicketTemplateRequest
  | DeleteKioskTicketTemplateSuccess
  | DeleteKioskTicketTemplateError
  | DeleteKioskTicketTemplatePending;
